import script from "./GridTemplateSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./GridTemplateSelector.vue?vue&type=script&setup=true&lang=js"

import "./GridTemplateSelector.vue?vue&type=style&index=0&id=c4dbd458&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4dbd458"]])

export default __exports__